<script>
    import {onMount} from 'svelte';
  import {sgettext} from '../../../i18n.js';
  import {
    isActivityVersionHeaderSelected,
    roles,
    activityVersion,
  } from '../workspacesStore.js';
  import { clearSelectedListItems } from './utils.js';

  export let valid;
  let expanded = false;

  function handleClick(event) {
    roles.set(clearSelectedListItems($roles));
    isActivityVersionHeaderSelected.set(true);
  }

  /**
   * Callback to Toggles the expand/collapse of the current role.
   * Setting all worksequences to match the role expand state
   */
  function toggleExpand(event) {
    expanded = !expanded;
    $roles.forEach(role => {
      role.worksequences.forEach(ws => {
        ws.expanded = expanded;
      })
    })
    $activityVersion.expanded = expanded;
    roles.set([...$roles]);
  }

</script>

<style>
  .panel {
    flex: 1;
    height: 100%;
  }

  .toggle {
    text-align: center;
    cursor: pointer;
    padding-right: 5px;
    text-overflow: unset !important;
  }
  
  .container {
    position: sticky;
    top: 0;
  }

  header {
    background-color: #5b5b5b;
    padding: 5px 0 5px 10px;
    color: white;
    display: flex;
    height: 34px;
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    cursor: pointer;
  }

  header.selected {
    background-color: #fab636;
    color: #000;
  }
</style>

<div class="panel wrapper" id="activity">
  <div class="container p-0">
    <header
      on:click={handleClick}
      class:selected={$isActivityVersionHeaderSelected}
    >
    <div class="toggle" on:mousedown|stopPropagation|preventDefault={toggleExpand}>
      <i class="fas" class:fa5-plus={!expanded} class:fa5-minus={expanded}/>
    </div>
    {#if !valid}
      <i class="fa fa-exclamation-circle text-danger mr-2 mt-1"></i>
    {/if}
    {sgettext('$$ACTIVITY_1$$')}: {#if $activityVersion?.name}{$activityVersion.name}{/if}  
    </header>
  </div>
</div>
